import { render, staticRenderFns } from "./ReportPageListItemFetching.vue?vue&type=template&id=b5d652c0&scoped=true&"
import script from "./ReportPageListItemFetching.vue?vue&type=script&lang=ts&"
export * from "./ReportPageListItemFetching.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPageListItemFetching.vue?vue&type=style&index=0&id=b5d652c0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d652c0",
  null
  
)

export default component.exports